<template>
  <v-container class="py-8 mx-auto">
    <v-row justify="center">
      <v-col cols="12" class="text-center mb-6">
        <h1 class="text-h4 font-weight-bold text-grey-darken-3">Empresas do Grupo</h1>
        <p class="text-subtitle-1 text-grey-darken-1">Escolha uma empresa para visualizar os eventos e informações</p>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12">
        <v-row>
          <v-col v-for="empresa in empresas" :key="empresa.rota" cols="12" sm="6" md="4">
            <v-card
              :to="empresa.rota"
              class="pa-4 card-empresa"
              elevation="0"
              variant="outlined"
              rounded="lg"
              hover
            >
              <div class="d-flex align-center">
                <v-avatar
                  :color="empresa.cor"
                  size="48"
                  class="mr-4 font-weight-bold"
                >
                  {{ empresa.siglas }}
                </v-avatar>
                <div>
                  <v-card-title class="pa-0 text-body-1 font-weight-bold">{{ empresa.nome }}</v-card-title>
                  <v-card-subtitle class="pa-0 text-caption">{{ empresa.subtitulo }}</v-card-subtitle>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'HomeIndex',
  data() {
    return {
      empresas: [
        { rota: '/previda', nome: 'Previda', subtitulo: 'Assistência Funeral', siglas: 'PR', cor: '#475569' },
        { rota: '/parquedasflores', nome: 'Parque das Flores', subtitulo: 'Cemitério', siglas: 'PF', cor: '#0ea5e9' },
        { rota: '/memorial', nome: 'Memorial Parque Maceió', subtitulo: 'Cemitério & Crematório', siglas: 'MM', cor: '#8b5cf6' },
        { rota: '/parquedoagreste', nome: 'Parque do Agreste', subtitulo: 'Cemitério', siglas: 'PA', cor: '#10b981' },
        { rota: '/cemiterioprevida', nome: 'Cemitério Previda', subtitulo: 'Cemitério', siglas: 'CP', cor: '#f59e0b' },
        { rota: '/cemiterioprevidaarapiraca', nome: 'Cemitério Previda Arapiraca', subtitulo: 'Cemitério', siglas: 'CA', cor: '#ef4444' },
      ],
    };
  },
};
</script>


<style scoped>

@import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;600;700&display=swap');

* {
  font-family: "Sora", sans-serif !important;
}
.card-empresa {
  transition: transform 0.2s ease;
  border-color: #cbd5e1;
  box-shadow: 0 10px 20px rgba(0,0,0,0.06);
  background-color: #fff;
}

.card-empresa:hover {
  transform: translateY(-2px);
}
</style>
